AFRAME.registerComponent('timeline-control', {
    schema: {
        timestamps: { type: 'array', default: [] }, // Format: ["YYYY-MM-DD HH:MM:SS[.000 TZ]" or "YYYY-MM-DD"]
        width: { type: 'number', default: 1 },
        height: { type: 'number', default: 0.05 },
        fontSize: { type: 'number', default: 0.1 },
        interval: { type: 'string', default: '1d' },
        previousCloseDate: { type: 'string', default: '' },
        dataSource: { type: 'string', default: '' }
    },

    init: function () {
        this.timestamps = [];
        this.currentIndex = 0;
        this.isDragging = false;
        this.controller = null;
        this.isAnimating = false;
        this.currentAnimationSession = 0;
        this.startDate = null;
        this.endDate = null;
        this.cameraEl = this.el.sceneEl.cameraEl;

        console.log('Initializing timeline-control component');

        this.isETTimeZone = true;
        try {
            const rawSettings = localStorage.getItem('mainSettings');
            if (rawSettings) {
                const parsed = JSON.parse(rawSettings);
                if (parsed && parsed.value && parsed.value.isETTimeZone === false) {
                    this.isETTimeZone = false;
                }
            }
        } catch (e) {
            console.warn('Failed to read timezone from localStorage', e);
        }

        document.addEventListener('timezone-changed', (e) => {
            if (e.detail && typeof e.detail.isETTimeZone === 'boolean') {
                console.log(`[Timeline] Timezone changed to: ${e.detail.isETTimeZone ? 'ET' : 'Local'}`);
                this.isETTimeZone = e.detail.isETTimeZone;
                if (this.timestamps.length > 0) {
                    this.updateTimeIndicators();
                    this.updateTimeline(this.timestamps[this.currentIndex], this.currentIndex, this.timestamps.length);
                }
            }
        });

        this.isAnimationOn = true;
        try {
            const configureData = localStorage.getItem('configureControlSettings');
            if (configureData) {
                const parsed = JSON.parse(configureData);
                if (parsed && parsed.value && typeof parsed.value.isAnimationOn === 'boolean') {
                    this.isAnimationOn = parsed.value.isAnimationOn;
                }
            }
        } catch (e) {
            console.warn('Failed to read isAnimationOn from localStorage', e);
        }

        document.addEventListener('configure-changed', (e) => {
            if (e.detail && e.detail.settings && typeof e.detail.settings.isAnimationOn === 'boolean') {
                const newState = e.detail.settings.isAnimationOn;
                this.isAnimationOn = newState;
                this.updatePlayButtonIcon(newState);
                
                // Stop any existing animation session by incrementing session ID
                this.currentAnimationSession = (this.currentAnimationSession || 0) + 1;

                if (!newState) {
                    this.isAnimating = false;
                    if (this.timestamps.length > 0) {
                        this.currentIndex = this.timestamps.length - 1;
                        this.updateTimeline(this.timestamps[this.currentIndex], this.currentIndex, this.timestamps.length);
                    }
                } else {
                    this.stopAnimation();
                    this.goToBeginning();
                }
            }
        });

        this.createTimelineUI();

        this.slider.addEventListener('mousedown', (event) => {
            event.stopPropagation();
            event.stopImmediatePropagation();
            event.preventDefault();
            this.isDragging = true;
            this.disableCameraControls();
            console.log('Mouse down on slider, dragging started');
            this.updateSliderFromMouse(event);
        });

        document.addEventListener('mousemove', (event) => {
            if (this.isDragging) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                this.updateSliderFromMouse(event);
            }
        }, { capture: true });

        document.addEventListener('mouseup', () => {
            if (this.isDragging) {
                this.isDragging = false;
                this.enableCameraControls();
                console.log('Mouse up, dragging ended');
                this.emitGotoTime();
            }
        });

        this.slider.addEventListener('triggerdown', (event) => {
            event.stopPropagation();
            this.isDragging = true;
            this.controller = event.target;
            console.log('VR trigger down on slider');
        });

        this.el.sceneEl.addEventListener('triggerup', () => {
            if (this.isDragging) {
                this.isDragging = false;
                this.controller = null;
                console.log('VR trigger up');
                this.emitGotoTime();
            }
        });

        this.slider.addEventListener('click', (event) => {
            event.stopPropagation();
            if (!this.isDragging && event.detail.intersection) {
                this.updateSliderFromRaycast(event.detail.intersection.point);
                this.emitGotoTime();
            }
        });

        this.el.addEventListener('timeline-update', (event) => {
            const { timestamp, index, total } = event.detail;
            this.updateTimeline(timestamp, index, total);
        });

        this.tick = AFRAME.utils.throttle(this.tick, 16, this);

        this.el.sceneEl.addEventListener('loaded', () => {
            console.log('Scene loaded, forcing render');
            this.el.sceneEl.renderer.render(this.el.sceneEl.object3D, this.el.sceneEl.camera);
        });
    },


    createTimelineUI: function () {
        const container = this.el;

        // Reset session ID on UI recreation to prevent old loops from affecting new UI state
        this.currentAnimationSession = (this.currentAnimationSession || 0) + 1;

        console.log('Creating timeline UI with a-troika-text labels');

        this.timelineBar = document.createElement('a-box');
        this.timelineBar.setAttribute('width', this.data.width);
        this.timelineBar.setAttribute('height', this.data.height);
        this.timelineBar.setAttribute('depth', 0.1);
        this.timelineBar.setAttribute('color', '#333');
        this.timelineBar.setAttribute('position', '0 0 0');
        this.timelineBar.setAttribute('data-raycastable', '');
        this.timelineBar.setAttribute('visible', true);
        container.appendChild(this.timelineBar);
        console.log('Timeline bar created: width=', this.data.width, 'height=', this.data.height);

        // this.slider = document.createElement('a-box');
        // this.slider.setAttribute('width', 0.05);
        // this.slider.setAttribute('height', this.data.height + 0.05);
        // this.slider.setAttribute('depth', 0.11);
        // this.slider.setAttribute('color', '#FFFFFF');
        // this.slider.setAttribute('position', '0 0 0.01');
        // this.slider.setAttribute('data-raycastable', '')

        this.slider = document.createElement("a-entity");
        this.slider.setAttribute("rounded-box", {
            width: this.data.height,
            height: this.data.height,
            depth: 0.11,
            color: "#fff",
            radius: this.data.height / 2,
        });
        this.slider.setAttribute('position', '0 0 0.01');
        this.slider.setAttribute('data-raycastable', '')

        this.el.sceneEl.addEventListener('theme-changed', e => {
            const theme = e.detail.themeMode;
            if (theme === 'Dark') {
                this.timelineBar.setAttribute('color', '#333');
                // this.slider.setAttribute("ui-button", { color: "#fff" });
            } else {
                this.timelineBar.setAttribute('color', '#AAA');
                // this.slider.setAttribute("ui-button", { color: "#fff" });
            }
        });

        container.appendChild(this.slider);
        console.log('Slider created: position=0 0 0.01');

        this.timestampText = document.createElement('a-troika-text');
        this.timestampText.classList.add('timeline-text');
        this.timestampText.setAttribute('value', '');
        this.timestampText.setAttribute('font-size', this.data.fontSize);
        this.timestampText.setAttribute('align', 'center');
        this.timestampText.setAttribute('color', 'white');
        this.timestampText.setAttribute('position', `0 ${this.data.height + 0.15} 0.05`);
        this.timestampText.setAttribute('visible', false);
        container.appendChild(this.timestampText);

        this.dateRangeText = document.createElement('a-troika-text');
        this.dateRangeText.classList.add('timeline-text');
        this.dateRangeText.setAttribute('value', '');
        this.dateRangeText.setAttribute('font-size', this.data.fontSize);
        this.dateRangeText.setAttribute('align', 'center');
        this.dateRangeText.setAttribute('color', 'white');
        this.dateRangeText.setAttribute('position', `0 ${this.data.height + 0.1} 0.01`);
        this.dateRangeText.setAttribute('visible', false);
        container.appendChild(this.dateRangeText);

        this.timeIndicators = [];
        const positions = [-this.data.width / 2, -this.data.width / 4, 0, this.data.width / 4, this.data.width / 2];
        positions.forEach((x, i) => {
            const indicator = document.createElement('a-troika-text');
            indicator.classList.add('timeline-text');
            indicator.setAttribute('value', '');
            indicator.setAttribute('font-size', this.data.fontSize * 0.8);
            indicator.setAttribute('align', 'center');
            indicator.setAttribute('color', '#FFF');
            indicator.setAttribute('position', `${x} ${-this.data.height - 0.15} 0.04`);
            indicator.setAttribute('visible', true);
            // indicator.setAttribute('rotation', '0 0 45');
            // indicator.classList.add('billboard');
            container.appendChild(indicator);
            this.timeIndicators.push(indicator);
            console.log(`timeIndicator[${i}] created: position=${x} ${-this.data.height - 0.05} 0.01, font-size=`, this.data.fontSize * 0.8, 'visible=', true);
        });

        this.toBeginningButton = document.createElement('a-plane');
        this.toBeginningButton.setAttribute('position', `-0.34 ${-this.data.height - 0.28} 0.01`);
        this.toBeginningButton.setAttribute('width', '0.14');
        this.toBeginningButton.setAttribute('height', '0.1');
        this.toBeginningButton.setAttribute('material', 'color: white; opacity: 0; transparent: true; shader: standard');

        const buttons = [
            { id: "toBeginning", image: "./vr-assets/player/back-2.png", position: `-0.4 ${-this.data.height - 0.33} 0.01`, action: this.goToBeginning },
            { id: "back", image: "./vr-assets/player/back.png", position: `-0.2 ${-this.data.height - 0.33} 0.01`, action: this.stepBackward },
            { id: "play", image: this.isAnimationOn ? "./vr-assets/player/pause.png" : "./vr-assets/player/play.png", position: `0 ${-this.data.height - 0.33} 0.01`, action: this.runFromCurrent },
            { id: "forward", image: "./vr-assets/player/forward.png", position: `0.2 ${-this.data.height - 0.33} 0.01`, action: this.stepForward },
            { id: "toEnd", image: "./vr-assets/player/forward-2.png", position: `0.4 ${-this.data.height - 0.33} 0.01`, action: this.goToEnd }
        ];
        buttons.forEach(btn => {
            const timeBtn = document.createElement("a-entity");
            timeBtn.setAttribute("id", btn.id);
            
            const isPlayPause = btn.id === 'play';
            const rotation = isPlayPause ? (this.isAnimationOn ? 0 : 45) : 45;
            const size = isPlayPause ? (this.isAnimationOn ? 0.18 : 0.15) : 0.15;
            
            timeBtn.setAttribute("ui-button", {
                label: "",
                image: btn.image || '',
                width: size,
                height: size,
                type: "rounded-box",
                colorScheme: 'primary',
                radius: 0.015,
                depth: 0.02,
                contentRotation: rotation,
            });
            timeBtn.setAttribute("position", btn.position);
            timeBtn.addEventListener("click", btn.action.bind(this));

            container.appendChild(timeBtn);
        });


        this.el.sceneEl.renderer.render(this.el.sceneEl.object3D, this.el.sceneEl.camera);
        console.log('Initial UI render forced');
    },

    normalizeTimestamp: function (ts) {
        if (typeof ts !== 'string') return ts;
        if (ts.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return `${ts} 16:00:00`;
        }
        return ts.replace(/\.\d{3}\s*(EST|EDT|CST|CDT|PST|PDT)?$/, '');
    },

    update: function (oldData) {
        if (this.data.timestamps && this.data.timestamps !== oldData.timestamps) {
            this.isAnimating = false;
            // Increment session to stop any running loops
            this.currentAnimationSession = (this.currentAnimationSession || 0) + 1;

            this.timestamps = this.data.timestamps.map(ts => this.normalizeTimestamp(ts));
            this.currentIndex = 0;

            if (this.timestamps.length > 0) {
                const firstTs = this.timestamps[0].split(' ')[0];
                const lastTs = this.timestamps[this.timestamps.length - 1].split(' ')[0];
                this.startDate = new Date(firstTs + 'T00:00:00Z');
                this.endDate = new Date(lastTs + 'T00:00:00Z');

                console.log(`Start date: ${firstTs}, end date: ${lastTs}`);
            } else {
                this.startDate = this.endDate = null;
            }

            this.updateTimeIndicators();
            const initialIdx = this.isAnimationOn ? 0 : this.timestamps.length - 1;
            this.currentIndex = initialIdx;
            this.updateTimeline(this.timestamps[initialIdx], initialIdx, this.timestamps.length);
            console.log('Forcing render after update');
            this.el.sceneEl.renderer.render(this.el.sceneEl.object3D, this.el.sceneEl.camera);
        }

        if ((this.data.previousCloseDate !== oldData.previousCloseDate || this.data.dataSource !== oldData.dataSource) &&
            this.timestamps.length > 0) {
            this.updateTimeline(this.timestamps[this.currentIndex], this.currentIndex, this.timestamps.length);
        }
    },

    updateTimeline: function (timestamp, index, total) {
        if (!this.timestamps.length && total > 0) {
            console.warn('No timestamps, initializing placeholders:', total);
            this.timestamps = Array(total).fill().map((_, i) => `Timestamp ${i}`);
            this.startDate = this.endDate = null;
            this.updateTimeIndicators();
        }

        const currentTimestamp = timestamp || this.timestamps[index];
        const isPercentChangeChart = !['dividend', 'dividend-sec', 'sip', 'sip-sec'].includes(this.data.dataSource);

        let dataAndTimeToDisplay;
        if (isPercentChangeChart && this.data.previousCloseDate) {
            dataAndTimeToDisplay = this.formatDateRange(currentTimestamp, this.data.previousCloseDate, this.data.interval);
        } else {
            const dateAndTime = this.formatDateAndTime(currentTimestamp);
            dataAndTimeToDisplay = `${dateAndTime.date} ${dateAndTime.time}`;
        }

        const currentTimeDateEl = document.querySelector('#current-time-date');
        if (currentTimeDateEl) currentTimeDateEl.setAttribute('value', dataAndTimeToDisplay);

        const normalizedCurrent = this.normalizeTimestamp(currentTimestamp);
        let localIdx = this.timestamps.indexOf(normalizedCurrent);
        if (localIdx === -1) {
            const datePart = (typeof normalizedCurrent === 'string') ? normalizedCurrent.split(' ')[0] : '';
            if (datePart) localIdx = this.timestamps.findIndex(ts => ts.split(' ')[0] === datePart);
        }
        if (localIdx !== -1) {
            this.currentIndex = localIdx;
        } else if (index >= 0 && index < this.timestamps.length) {
            this.currentIndex = index;
        }

        const calculatedTotal = (this.timestamps && this.timestamps.length > 0) ? this.timestamps.length : (total || 0);
        const sliderX = calculatedTotal > 1 ? (this.currentIndex / (calculatedTotal - 1)) * this.data.width - (this.data.width / 2) : (calculatedTotal === 1 ? this.data.width / 2 : 0);
        this.slider.object3D.position.set(sliderX, 0, 0.01);
        this.slider.object3D.updateMatrix();

        const isSameDay = this.startDate && this.endDate &&
            this.startDate.getUTCFullYear() === this.endDate.getUTCFullYear() &&
            this.startDate.getUTCMonth() === this.endDate.getUTCMonth() &&
            this.startDate.getUTCDate() === this.endDate.getUTCDate();

        if (isSameDay) {
            const parts = timestamp ? timestamp.split(' ') : [''];
            const timeStr = this.getDisplayTime(timestamp);
            this.timestampText.setAttribute('value', timeStr);
            this.timestampText.setAttribute('visible', true);
            this.dateRangeText.setAttribute('visible', false);
        } else {
            if (timestamp) {
                const datePart = timestamp.split(' ')[0];
                const currentDate = new Date(datePart + 'T00:00:00Z');

                if (!isNaN(currentDate.getTime())) {
                    const month = (currentDate.getUTCMonth() + 1).toString();
                    const day = currentDate.getUTCDate().toString();
                    const year = currentDate.getUTCFullYear();
                    const currentDateStr = `${month}/${day}/${year.toString().slice(-2)}`;

                    this.dateRangeText.setAttribute('value', currentDateStr);
                    this.dateRangeText.setAttribute('visible', true);
                    this.timestampText.setAttribute('visible', false);
                } else {
                    this.dateRangeText.setAttribute('value', 'N/A');
                    this.dateRangeText.setAttribute('visible', true);
                    this.timestampText.setAttribute('visible', false);
                }
            } else {
                this.dateRangeText.setAttribute('value', 'N/A');
                this.dateRangeText.setAttribute('visible', true);
                this.timestampText.setAttribute('visible', false);
            }
        }

        this.el.sceneEl.renderer.render(this.el.sceneEl.object3D, this.el.sceneEl.camera);
    },

    showDateRange: function () {
        if (this.startDate && this.endDate) {
            const startYear = this.startDate.getUTCFullYear();
            const endYear = this.endDate.getUTCFullYear();
            const startMonth = (this.startDate.getUTCMonth() + 1).toString().padStart(2, '0');
            const endMonth = (this.endDate.getUTCMonth() + 1).toString().padStart(2, '0');
            const startDay = this.startDate.getUTCDate().toString().padStart(2, '0');
            const endDay = this.endDate.getUTCDate().toString().padStart(2, '0');
            const rangeStr = startYear !== endYear
                ? `${startYear}-${startMonth}-${startDay} - ${endYear}-${endMonth}-${endDay}`
                : `${startMonth}/${startDay} - ${endMonth}/${endDay}`;
            this.dateRangeText.setAttribute('value', rangeStr);
            this.dateRangeText.setAttribute('visible', true);
            this.timestampText.setAttribute('visible', false);
            this.dateRangeText.object3D.updateMatrix();
        } else {
            this.dateRangeText.setAttribute('value', 'No valid dates');
            this.dateRangeText.setAttribute('visible', true);
            this.timestampText.setAttribute('visible', false);
            this.dateRangeText.object3D.updateMatrix();
        }
    },

    updateTimeIndicators: function () {
        console.log('Updating timeIndicators');
        console.info('Timestamps to update indicators:', this.timestamps);

        if (this.timestamps.length < 1) {
            console.warn('Not enough timestamps to update indicators:', this.timestamps.length);
            this.timeIndicators.forEach((indicator, i) => {
                indicator.setAttribute('value', '');
                indicator.object3D.visible = false;
            });
            return;
        }

        const isSameDay = this.startDate && this.endDate &&
            this.startDate.getFullYear() === this.endDate.getFullYear() &&
            this.startDate.getMonth() === this.endDate.getMonth() &&
            this.startDate.getDate() === this.endDate.getDate();

        const n = this.timestamps.length;
        let indices;
        if (n === 1) {
            indices = [null, null, null, null, 0];
        } else if (n === 2) {
            indices = [0, null, null, null, 1];
        } else if (n === 3) {
            indices = [0, null, 1, null, 2];
        } else if (n === 4) {
            indices = [0, 1, null, 2, 3];
        } else {
            const step = Math.floor((n - 1) / 4);
            indices = [0, step, step * 2, step * 3, n - 1];
        }

        if (isSameDay) {
            this.timeIndicators.forEach((indicator, i) => {
                const idx = indices[i];
                if (idx === null || idx === undefined) {
                    indicator.setAttribute('value', '');
                    indicator.object3D.visible = false;
                    return;
                }
                const timeStr = this.getDisplayTimeWithoutMinutes(this.timestamps[idx]);
                indicator.setAttribute('value', timeStr);
                indicator.object3D.visible = true;
                indicator.object3D.updateMatrix();
            });
        } else {
            console.log('Multi-day dataset, showing dates');
            const selectedTimestamps = indices.map(idx => idx !== null ? this.timestamps[idx] : null);

            const indicatorDates = [];
            const sameYear = this.startDate && this.endDate && this.startDate.getFullYear() === this.endDate.getFullYear();

            selectedTimestamps.forEach((timestamp, i) => {
                if (!timestamp) {
                    indicatorDates.push('');
                    return;
                }

                const datePart = (typeof timestamp === 'string') ? timestamp.split(' ')[0] : '';
                if (!datePart) {
                    indicatorDates.push('');
                    return;
                }

                const date = new Date(datePart + 'T00:00:00Z');
                if (isNaN(date.getTime())) {
                    indicatorDates.push('');
                    return;
                }

                const month = (date.getUTCMonth() + 1).toString();
                const day = date.getUTCDate().toString();
                const year = date.getUTCFullYear();
                const dateStr = sameYear ? `${month}/${day}` : `${year}-${month}-${day}`;
                indicatorDates.push(dateStr);
            });

            this.timeIndicators.forEach((indicator, i) => {
                const val = indicatorDates[i];
                if (!val) {
                    indicator.setAttribute('value', '');
                    indicator.object3D.visible = false;
                    return;
                }

                indicator.setAttribute('value', val);
                indicator.object3D.visible = true;
                indicator.object3D.updateMatrix();
            });
        }

        this.el.sceneEl.renderer.render(this.el.sceneEl.object3D, this.el.sceneEl.camera);
    },

    stopAnimation: function () {
        if (this.isAnimating) {
            this.isAnimating = false;
            // Always increment session to invalidate current loops
            this.currentAnimationSession = (this.currentAnimationSession || 0) + 1;
            this.updatePlayButtonIcon(false);
            console.log('Animation stopped, session invalidated');
        }
    },

    updatePlayButtonIcon: function (isPlaying) {
        const playBtn = this.el.querySelector('#play');
        if (playBtn) {
            const icon = isPlaying ? './vr-assets/player/pause.png' : './vr-assets/player/play.png';
            const rotation = isPlaying ? 0 : 45;
            const size = isPlaying ? 0.18 : 0.15;
            
            playBtn.setAttribute('ui-button', {
                image: icon,
                contentRotation: rotation,
                width: size,
                height: size
            });
        }
    },

    goToBeginning: function () {
        if (this.timestamps.length === 0) return;
        this.stopAnimation();
        this.currentIndex = 0;
        const timestamp = this.timestamps[this.currentIndex];
        console.log(`Going to beginning: index=${this.currentIndex}, timestamp=${timestamp}`);
        this.updateTimeline(timestamp, this.currentIndex, this.timestamps.length);
        this.emitGotoTime();

        if (window.gtag) gtag('event', `VR_CenterPanel_AnimationControl`);
    },

    goToEnd: function () {
        if (this.timestamps.length === 0) return;
        this.stopAnimation();
        this.currentIndex = this.timestamps.length - 1;
        const timestamp = this.timestamps[this.currentIndex];
        console.log(`Going to end: index=${this.currentIndex}, timestamp=${timestamp}`);
        this.updateTimeline(timestamp, this.currentIndex, this.timestamps.length);
        this.emitGotoTime();

        if (window.gtag) gtag('event', `VR_CenterPanel_AnimationControl`);
    },

    stepForward: function () {
        if (this.timestamps.length === 0) return;
        this.stopAnimation();
        if (this.currentIndex < this.timestamps.length - 1) {
            this.currentIndex++;
            const timestamp = this.timestamps[this.currentIndex];
            console.log(`Stepping forward: index=${this.currentIndex}, timestamp=${timestamp}`);
            this.updateTimeline(timestamp, this.currentIndex, this.timestamps.length);
            this.emitGotoTime();

            if (window.gtag) gtag('event', `VR_CenterPanel_AnimationControl`);
        }
    },

    stepBackward: function () {
        console.log(`Stepping backward: this.currentIndex=${this.currentIndex}`);
        if (this.timestamps.length === 0) return;
        this.stopAnimation();
        if (this.currentIndex > 0) {
            this.currentIndex--;
            const timestamp = this.timestamps[this.currentIndex];
            console.log(`Stepping backward: index=${this.currentIndex}, timestamp=${timestamp}`);
            this.updateTimeline(timestamp, this.currentIndex, this.timestamps.length);
            this.emitGotoTime();

            if (window.gtag) gtag('event', `VR_CenterPanel_AnimationControl`);
        }
    },

    runFromCurrent: async function () {
        if (this.timestamps.length === 0) return;

        if (this.isAnimating) {
            this.stopAnimation();
            return;
        }

        this.isAnimating = true;
        this.currentAnimationSession = (this.currentAnimationSession || 0) + 1;
        const session = this.currentAnimationSession;
        this.updatePlayButtonIcon(true);
        console.log(`Running loop for session=${session} from index=${this.currentIndex}`);

        for (let i = this.currentIndex; i < this.timestamps.length; i++) {
            if (!this.isAnimating || this.currentAnimationSession !== session) {
                console.log(`Loop for session=${session} aborted at index=${i}`);
                return;
            }
            const timestamp = this.timestamps[i];
            console.log(`Animating to index=${i}, timestamp=${timestamp}`);
            this.updateTimeline(timestamp, i, this.timestamps.length);
            this.el.emit('goto-time', { timestamp, index: i }, true);
            await new Promise(resolve => setTimeout(resolve, 500));
            if (!this.isAnimating || this.currentAnimationSession !== session) {
                console.log(`Loop for session=${session} aborted after delay at index=${i}`);
                return;
            }
        }

        if (this.currentAnimationSession === session) {
            this.isAnimating = false;
            this.updatePlayButtonIcon(false);
        }

        if (window.gtag) gtag('event', `VR_CenterPanel_AnimationControl`);
    },

    updateSliderFromMouse: function (event) {
        const mouse = new THREE.Vector2();
        mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

        const raycaster = new THREE.Raycaster();
        const camera = this.el.sceneEl.camera;
        raycaster.setFromCamera(mouse, camera);

        const intersects = raycaster.intersectObject(this.timelineBar.object3D, true);
        if (intersects.length > 0) {
            const point = intersects[0].point;
            const localPoint = this.timelineBar.object3D.worldToLocal(point.clone());
            const clampedX = Math.max(-this.data.width / 2, Math.min(this.data.width / 2, localPoint.x));

            this.slider.object3D.position.set(clampedX, 0, 0.01);
            this.slider.object3D.updateMatrix();

            if (this.timestamps.length > 0) {
                const fraction = (clampedX + this.data.width / 2) / this.data.width;
                this.currentIndex = Math.round(fraction * (this.timestamps.length - 1));
                console.log(`Slider moved: index=${this.currentIndex}, timestamp=${this.timestamps[this.currentIndex]}`);
                this.updateTimeline(this.timestamps[this.currentIndex], this.currentIndex, this.timestamps.length);
            }
        }
    },

    updateSliderFromRaycast: function (point) {
        const localPoint = this.timelineBar.object3D.worldToLocal(point.clone());
        const clampedX = Math.max(-this.data.width / 2, Math.min(this.data.width / 2, localPoint.x));
        this.slider.object3D.position.set(clampedX, 0, 0.01);
        this.slider.object3D.updateMatrix();

        if (this.timestamps.length > 0) {
            const fraction = (clampedX + this.data.width / 2) / this.data.width;
            this.currentIndex = Math.round(fraction * (this.timestamps.length - 1));
            this.updateTimeline(this.timestamps[this.currentIndex], this.currentIndex, this.timestamps.length);
        }
    },

    disableCameraControls: function () {
        if (this.cameraEl) {
            const controls = this.cameraEl.components['look-controls'];
            if (controls) {
                controls.data.enabled = false;
                console.log('Camera look-controls disabled');
            }
        }
    },

    enableCameraControls: function () {
        if (this.cameraEl) {
            const controls = this.cameraEl.components['look-controls'];
            if (controls) {
                controls.data.enabled = true;
                console.log('Camera look-controls enabled');
            }
        }
    },
    
    
    getDisplayTime: function (etTimestamp) {
        if (!etTimestamp) return '';

        const to12Hour = (h, m) => {
            const isPM = h >= 12;
            const hour12 = h % 12 || 12;
            return `${hour12}:${m.toString().padStart(2, '0')} ${isPM ? 'PM' : 'AM'}`;
        };

        if (this.isETTimeZone) {
            const parts = etTimestamp.split(' ');
            if (!parts[1]) return '';

            const [h, m] = parts[1].substring(0, 5).split(':').map(Number);
            return to12Hour(h, m);
        } else {
            try {
                const [datePart, timePart] = etTimestamp.split(' ');
                if (!datePart || !timePart) return '';

                const d = new Date(`${datePart}T${timePart}Z`);

                const isMatch = (dateObj, targetHour, targetMinute) => {
                    const parts = new Intl.DateTimeFormat('en-US', {
                        timeZone: 'America/New_York',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: false
                    }).formatToParts(dateObj);

                    const h = parseInt(parts.find(p => p.type === 'hour').value, 10) % 24;
                    const m = parseInt(parts.find(p => p.type === 'minute').value, 10);
                    return h === targetHour && m === targetMinute;
                };

                const [hStr, mStr] = timePart.split(':');
                const targetH = parseInt(hStr, 10);
                const targetM = parseInt(mStr, 10);

                let validUTC = new Date(d.getTime() + 5 * 60 * 60 * 1000);

                if (!isMatch(validUTC, targetH, targetM)) {
                    validUTC = new Date(d.getTime() + 4 * 60 * 60 * 1000);
                }

                const localH = validUTC.getHours();
                const localM = validUTC.getMinutes();

                return to12Hour(localH, localM);

            } catch (e) {
                console.warn('Error converting ET to Local:', e);
                const parts = etTimestamp.split(' ');
                if (!parts[1]) return '';

                const [h, m] = parts[1].substring(0, 5).split(':').map(Number);
                return to12Hour(h, m);
            }
        }
    },
    getDisplayTimeWithoutMinutes: function (etTimestamp) {
        if (!etTimestamp) return '';

        const to12Hour = (h) => {
            const isPM = h >= 12;
            const hour12 = h % 12 || 12;
            return `${hour12} ${isPM ? 'PM' : 'AM'}`;
        };

        if (this.isETTimeZone) {
            const parts = etTimestamp.split(' ');
            if (!parts[1]) return '';

            const [h] = parts[1].substring(0, 5).split(':').map(Number);
            return to12Hour(h);
        } else {
            try {
                const [datePart, timePart] = etTimestamp.split(' ');
                if (!datePart || !timePart) return '';

                const d = new Date(`${datePart}T${timePart}Z`);

                const isMatch = (dateObj, targetHour, targetMinute) => {
                    const parts = new Intl.DateTimeFormat('en-US', {
                        timeZone: 'America/New_York',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: false
                    }).formatToParts(dateObj);

                    const h = parseInt(parts.find(p => p.type === 'hour').value, 10) % 24;
                    const m = parseInt(parts.find(p => p.type === 'minute').value, 10);
                    return h === targetHour && m === targetMinute;
                };

                const [hStr, mStr] = timePart.split(':');
                const targetH = parseInt(hStr, 10);
                const targetM = parseInt(mStr, 10);

                let validUTC = new Date(d.getTime() + 5 * 60 * 60 * 1000);

                if (!isMatch(validUTC, targetH, targetM)) {
                    validUTC = new Date(d.getTime() + 4 * 60 * 60 * 1000);
                }

                const localH = validUTC.getHours();

                return to12Hour(localH);

            } catch (e) {
                console.warn('Error converting ET to Local in getDisplayTimeWithoutMinutes:', e);
                const parts = etTimestamp.split(' ');
                if (!parts[1]) return '';

                const [h] = parts[1].substring(0, 5).split(':').map(Number);
                return to12Hour(h);
            }
        }
    },
    
    getDisplayDate: function (etTimestamp) {
        if (!etTimestamp) return '';
        const [year, month, day] = etTimestamp.split('-').map(Number);
        if (!year || !month || !day) return '';
        return `${month}/${day}/${year.toString().slice(-2)}`;
    },

    formatDateRange: function(currentTimestamp, previousCloseDate, interval) {
        if (!currentTimestamp || !previousCloseDate) {
            console.warn('formatDateRange: missing timestamp or previousCloseDate', { currentTimestamp, previousCloseDate });
            return (typeof currentTimestamp === 'string') ? currentTimestamp.split(' ')[0] : '';
        }
        try {
            const currentDatePart = currentTimestamp.split(' ')[0];
            const currentTimePart = currentTimestamp.split(' ')[1] || '16:00:00';

            const currentDate = new Date(currentDatePart + 'T00:00:00Z');
            const previousDate = new Date(previousCloseDate + 'T00:00:00Z');

            if (isNaN(currentDate.getTime()) || isNaN(previousDate.getTime())) {
                console.warn('Invalid dates for range formatting', { currentDatePart, previousCloseDate });
                return currentDatePart;
            }

            const formatDateShort = (date) => {
                const month = date.getUTCMonth() + 1;
                const day = date.getUTCDate();
                return `${month}/${day}`;
            };

            const currentDateFormatted = formatDateShort(currentDate);
            const previousDateFormatted = formatDateShort(previousDate);

            const timeFormatter = new Intl.DateTimeFormat('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            });

            if (interval && interval.toLowerCase() === '1d') {
                const currentDisplayTime = this.formatDateAndTime(currentTimestamp).time;

                return `${currentDateFormatted} ${currentDisplayTime} vs. ${previousDateFormatted} EOD`;
            } else {
                return `${currentDateFormatted} EOD vs. ${previousDateFormatted} EOD`;
            }
        } catch (error) {
            console.error('Error formatting date range:', error);
            return (typeof currentTimestamp === 'string') ? currentTimestamp.split(' ')[0] : '';
        }
    },

    formatDateAndTime: function(sourceDateAndTime) {
        if (!sourceDateAndTime) return { time: '', date: '' };

        const cleanIso = sourceDateAndTime.trim().replace(/\s[A-Z]{3,4}$/, '').replace(' ', 'T');

        let dateObj;

        if (this.isETTimeZone) {
            dateObj = new Date(cleanIso);
        } else {
            const tempDate = new Date(cleanIso);
            const nyString = tempDate.toLocaleString('en-US', { timeZone: 'America/New_York' });
            const nyDate = new Date(nyString);
            const offsetDiff = tempDate - nyDate;

            dateObj = new Date(tempDate.getTime() + offsetDiff);
        }

        const timeFormatter = new Intl.DateTimeFormat('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            ...(!this.isETTimeZone && { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone })
        });

        const dateFormatter = new Intl.DateTimeFormat('en-US', {
            month: 'numeric',
            day: 'numeric',
            year: '2-digit',
            ...(!this.isETTimeZone && { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone })
        });

        return {
            time: timeFormatter.format(dateObj),
            date: dateFormatter.format(dateObj)
        };
    },
    

    tick: function () {
        if (this.isDragging && this.controller) {
            const raycaster = this.controller.components.raycaster;
            if (raycaster && raycaster.intersections.length > 0) {
                const intersection = raycaster.intersections.find(i => i.object.el === this.timelineBar);
                if (intersection) {
                    this.updateSliderFromRaycast(intersection.point);
                }
            }
        }
    },

    emitGotoTime: function () {
        const timestamp = this.timestamps[this.currentIndex];
        console.log(`Emitting goto-time: timestamp=${timestamp}, index=${this.currentIndex}`);
        this.el.emit('goto-time', { timestamp, index: this.currentIndex }, true);
    }
});
